import { BuilderElement, BuilderStore } from '@builder.io/react';

export const TOP_OF_THE_PAGE_SPACING =
  'u-p-t-lg-xxl-6 u-p-t-xl u-p-b-lg-xxl-18 u-p-b-xxl-6';
export const DEFAULT_SPACING = 'u-p-v-lg-xxl-18 u-p-v-xxl-6';
export const SAME_BACKGROUND_SPACING = 'u-p-b-lg-xxl-18 u-p-b-xxl-6';

export function getBlocks(blocks: BuilderElement[]) {
  const lastBlock = blocks[blocks.length - 1];
  // Builder Pixel gets insert only in published page
  // So, it should gets remove when computing spacing
  // because it makes the position especially the
  // bottom one wrong.
  if (lastBlock.id?.startsWith('builder-pixel')) {
    return blocks.slice(0, blocks.length - 1);
  }
  return blocks;
}

export function getBlockIndex(
  builderBlock?: BuilderElement,
  builderState?: BuilderStore
) {
  if (!builderBlock || !builderState) return -1;
  const blocks = getBlocks(builderState.content.data.blocks);
  return blocks.indexOf(builderBlock);
}

export function getNextBlock(
  builderBlock?: BuilderElement,
  builderState?: BuilderStore
) {
  if (!builderBlock || !builderState) return undefined;

  const blocks = getBlocks(builderState.content.data.blocks);
  const blockIndex = blocks.indexOf(builderBlock);
  return blocks[blockIndex + 1];
}

export function getPreviousBlock(
  builderBlock?: BuilderElement,
  builderState?: BuilderStore
) {
  if (!builderBlock || !builderState) return undefined;

  const blocks = getBlocks(builderState.content.data.blocks);
  const blockIndex = blocks.indexOf(builderBlock);
  return blocks[blockIndex - 1];
}

export function getBlockColor(block?: BuilderElement) {
  return block?.component?.options.backgroundColorClassName;
}

export const getBuilderSpacingClass = (
  builderBlock?: BuilderElement,
  builderState?: BuilderStore
) => {
  if (!builderBlock || !builderState) return DEFAULT_SPACING;

  const blocks = getBlocks(builderState.content.data.blocks);
  const blockIndex = blocks.indexOf(builderBlock);

  if (blockIndex === -1) return DEFAULT_SPACING;
  const currentBackground =
    builderBlock.component?.options.backgroundColorClassName;

  if (blockIndex === 0) return TOP_OF_THE_PAGE_SPACING;

  const previousBlock = blocks[blockIndex - 1];
  const previousBackground =
    previousBlock.component?.options.backgroundColorClassName;

  if (currentBackground === previousBackground) {
    return SAME_BACKGROUND_SPACING;
  }

  return DEFAULT_SPACING;
};
